import classNames from '@/utils/className';
import { ReactNode } from 'react';

export const ProfileHeaderContainer = ({ children, round = false }: { children: ReactNode | ReactNode[]; round?: boolean }) => {
  const variants = {
    round: {
      true: '[&>figure]:rounded-half [&>figure>img]:rounded-half',
      false: '[&>figure]:rounded-lg',
    },
  };
  return (
    <header
      className={classNames(
        'mb-6 mt-[-120px] flex flex-col items-center gap-4 pt-6 tablet:mb-0 [&>figure]:inline-block [&>figure]:h-[120px] [&>figure]:w-[120px] [&>figure]:border-4 [&>figure]:border-solid [&>figure]:border-mglGray50 [&>figure]:bg-gray-50 [&>figure]:shadow-mdc-elevation-z3-2',
        variants.round[round.toString()]
      )}>
      {children}
    </header>
  );
};

export const ProfileHeaderTitle = ({ children }: { children: ReactNode | ReactNode[] }) => (
  <h1 className="text-center text-[1.75rem] text-mglGray900">{children}</h1>
);

export const ProfileHeaderCover = ({ blueBackground = false }: { blueBackground?: boolean }) => {
  const variants = {
    blueBackground: {
      true: 'bg-mglBlue400',
      false: 'bg-mglGray700',
    },
  };
  return <div className={classNames('h-[120px] w-full rounded-lg', variants.blueBackground[blueBackground.toString()])} />;
};

export default {};
